/**
 * @fileoverview IMPORTANT FILE
 *
 * PRO FORMA STORE: this file holds the main data for the pro forma.
 * It also contains functions for updating the pro forma data
 */

import { create } from "zustand";
import useAuthStore from "./useAuthStore";
import { getFleetData } from "../utils/vehicleMatch";
import { patchFleet } from "../api/fleetApi";
import { clearMasterAccessByCodeCache } from "../api/masteraccessapi";
const useProForma = create((set, get) => ({
  // Define your state properties here
  fleetData: [],
  replacementOptionsMap: {},
  controls: {},
  advancedControls: {},
  yearOverYear: {},
  phases: [],
  years: {},
  proFormaCalcs: {},
  allSitesProFormaCalcs: {},
  allSitesYearOverYear: {},
  cityInfo: {},
  parentData: null,
  setParentData: (data) => set({ parentData: data }),
  cityAccess: null,
  setCityAccess: (data) => set({ cityAccess: data }),
  /** Master access: lowercase username → display city name (from city info). */
  cityNameByUsername: {},
  setCityNameByUsername: (next) => set({ cityNameByUsername: next }),

  /**
   * @function updateFleet - This function makes an api request to update the fleet data and then calls fetchAndUpdateFleet
   */
  updateFleet: async (event, value) => {
    const equipment_id = event.data.equipment_id;
    const field = event.colDef.field;
    try {
      const body = {
        [field]: value,
        equipment_id: equipment_id,
      };
      const response = await patchFleet(body);
      if (response.error) {
        throw new Error("Failed to update data");
      }
      get().fetchAndUpdateFleet("fleetData");
    } catch (error) {
      console.error("Error updating data:", error);
    }
  },
  updateEvalYear: async (year) => {
    get().years.EVAL_YEAR = year;
    set({ years: get().years });
  },

  /**
   * @function fetchAndUpdateFleet - This function fetches the all data and updates the state
   * Any time a change is made that would influence calculations, this function is called
   * Very important function
   *
   * @param {string} field - which field is updated
   */
  fetchAndUpdateFleet: async (field) => {
    const { user } = useAuthStore.getState();
    if (!user) {
      return;
    }
    try {
      const data = await getFleetData(user.id, field);
      set({
        fleetData: data.fleetData,
        replacementOptionsMap: data.replacementOptionsMap,
        yearOverYear: data.yearOverYear,
        phases: data.phases,
        controls: data.controls,
        advancedControls: data.advancedControls,
        years: data.years,
        proFormaCalcs: data.proFormaCalcs,
        allSitesProFormaCalcs: data.allSitesProFormaCalcs,
        allSitesYearOverYear: data.allSitesYearOverYear,
        chargerCost: data.chargerCost,
        cityInfo: data.cityInfo,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  /**
   * @function resetFleet - This function resets the fleet data, called when a user logs out
   */
  resetFleet: () => {
    clearMasterAccessByCodeCache();
    set({
      fleetData: [],
      replacementOptionsMap: {},
      yearOverYear: {},
      phases: [],
      controls: {},
      advancedControls: {},
      years: {},
      proFormaCalcs: {},
      allSitesProFormaCalcs: {},
      allSitesYearOverYear: {},
      cityInfo: {},
      parentData: null,
      cityAccess: null,
      cityNameByUsername: {},
    });
  },
}));

export default useProForma;
